import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getGallectionDeviationStreamId } from '../helpers';
import { fetchMoreGallectionDeviations } from '../actions';
import {
  getCurrentFolderId,
  getCurrentSubfolderId,
  getSearchQuery,
  getCurrentMediaSource,
} from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
import { PapiDeviation } from '@wix/da-papi-types';

export type WithGallectionDeviationsProps = {
  deviations: PapiDeviation[];
  hasMore: boolean;
  isFetching: boolean;
  isInitialized: boolean;
  fetchMoreGallectionDeviations: () => any;
};

const mapStateToProps = state => {
  const mediaSourceType = getCurrentMediaSource(state);
  const currentFolderId = getCurrentFolderId(state);
  const currentSubfolderId = getCurrentSubfolderId(state);

  const searchQuery = getSearchQuery(state);
  const streamId = getGallectionDeviationStreamId(
    mediaSourceType,
    currentSubfolderId || currentFolderId,
    searchQuery
  );
  return {
    deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
    hasMore: selectors.hasMore(state, streamId),
    isInitialized: selectors.isInitialized(state, streamId),
    isFetching: selectors.isFetching(state, streamId),
  };
};

export const useCurrentGallectionDeviations = (): WithGallectionDeviationsProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
  ...useMMDispatchActions({
    fetchMoreGallectionDeviations,
  }),
});

export default connectMediaStore(mapStateToProps, {
  fetchMoreGallectionDeviations,
});
